import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createStaticVNode as _createStaticVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createStaticVNode("<div class=\"container-fluid\"><div class=\"row\"><div class=\"col mt-3 sc-placeholder\"><a> </a></div></div></div><div class=\"container-fluid\"><div class=\"row\"><div class=\"col fixed-bottom mt-3 text-center bg-light shadow-sm\"><span class=\"text-dark\"> 衢州广电传媒集团·无线衢州 </span></div></div></div>", 2)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_shares = _resolveComponent("shares")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _hoisted_1,
    _createVNode(_component_shares)
  ], 64))
}